<div class="overlay">
  <div class="top-right">
    <select id="seite" [(ngModel)]="selectedSide" (change)="onSeiteDropDownSelect($event)">
      <!-- <option value="both">Gesamtscore</option> -->
      <!-- <option value="both">▲ links und ◼ rechts</option> -->
      <option value="left">
        ▲ links {{ patient.affectedSide === 'l' || patient.affectedSide === 'b' ? '(betroffen)' : '' }}
      </option>
      <option value="right">
        ◼ rechts {{ patient.affectedSide === 'r' || patient.affectedSide === 'b' ? '(betroffen)' : '' }}
      </option>
    </select>
  </div>
</div>
<canvas style="width: 100%" #canvas [id]="chartId">{{ chart }}</canvas>
